import { Component, Input } from '@angular/core';

/**
 * Volvo Group line icon component.
 * Uses MIT-licensed Feather Icons paths (feathericons.com) styled to match
 * the Volvo Group icon guidelines: 1.75px stroke, rounded caps/joins, no fill.
 */
const ICONS: Record<string, string> = {
  // Navigation / Actions
  'home':          'M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM9 22V12h6v10',
  'search':        'M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z',
  'check':         'M20 6L9 17l-5-5',
  'warning':       'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01',
  'plus':          'M12 5v14M5 12h14',
  'close':         'M18 6L6 18M6 6l12 12',
  'trash':         'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6',
  'edit':          'M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z',
  'save':          'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v13a2 2 0 0 1-2 2zM17 21v-8H7v8M7 3v5h8',
  'refresh':       'M23 4v6h-6M1 20v-6h6M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15',

  // Navigation arrows
  'arrow-left':        'M19 12H5M12 19l-7-7 7-7',
  'arrow-right':       'M5 12h14M12 5l7 7-7 7',
  'chevron-left':      'M15 18l-6-6 6-6',
  'chevron-right':     'M9 18l6-6-6-6',
  'chevron-first':     'M19 20L9 12l10-8M5 19V5',
  'chevron-last':      'M5 20l10-8L5 4M19 19V5',

  // People / Org
  'users':         'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75',

  // System / Config
  'settings':      'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z',

  // Data / Docs
  'chart-bar':     'M18 20V10M12 20V4M6 20v-6',
  'document':      'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM14 2v6h6M16 13H8M16 17H8M10 9H8',
  'layers':        'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5',

  // Domain specific
  'vehicle':       'M5 8l2-5h10l2 5v7H5V8zM3 15h18M8 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM16 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
  'wrench':        'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z',
  'mail':          'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2zM22 6l-10 7L2 6',
  'clock':         'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 6v6l4 2',
};

@Component({
  selector: 'vg-icon',
  standalone: true,
  template: `
    <svg
      [attr.width]="size"
      [attr.height]="size"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      [attr.stroke-width]="strokeWidth"
      stroke-linecap="round"
      stroke-linejoin="round"
      style="display:inline-block;vertical-align:middle;flex-shrink:0;"
      [attr.aria-label]="name"
      role="img"
    >
      <path [attr.d]="iconPath" />
    </svg>
  `,
})
export class VgIconComponent {
  @Input() name = '';
  @Input() size: number | string = 18;
  @Input() strokeWidth: number | string = 1.75;

  get iconPath(): string {
    return ICONS[this.name] ?? '';
  }
}
